module.exports = __webpack_public_path__ + "static/img/NZ.ad363652.svg";